<template>
  <div class="recommended_list" v-if="list_arr.length>0">
    <div class="recommended_li" @click="details(liem)" v-for="(liem,index) in list_arr" :key="index">
      <!-- 左边摘要 -->
      <div class="flex_between left_text text_div div_zuoyou" v-if="liem.summary_location == 3">
        <h3 class="list_title clamp1">
          <span class="list_tag" v-for="lise in liem.lable" :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
          <!-- {{liem.title | formatet}} -->
          <!-- {{formatet(liem.title)}} -->
          <span v-html="formatet(liem.title)"></span>

        </h3>
        <div class="list_left flex_between">

          <div class="original clamp1 flex_center"><span>原创：<span v-html="formatet(liem.user)"></span></span> <span class="time clamp1">{{liem.create_time}}</span></div>
          <div class="list_describe clamp3" v-html="formatet(liem.content)">
          </div>
          <div class="list_time flex_between">
            <div class="flex_center operation">
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/liulanP.png" alt=""></i>
                {{liem.see}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                {{liem.goods}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                {{liem.comment}}
              </div>
            </div>
          </div>
        </div>
        <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="">
          <i class="contain_video">
            <video controlslist='nodownload' oncontextmenu="return false" ref="video" :src="liem.cover_video" preload controls :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"></video>
          </i>
        </div>
        <div class="list_right flex_center" v-else>
          <i class="contain_img" v-for="(liemT,indexT) in liem.cover" v-if="indexT<3">
            <img v-if="liemT" :src="liemT" alt="">
            <img v-else src="@/assets/img/app_logo.png" alt="">
          </i>
        </div>
      </div>
      <!-- 右边摘要 -->
      <div class="flex_between rigth_text left_text text_div div_zuoyou" v-if="liem.summary_location == 4">
        <h3 class="list_title clamp1">
          <span class="list_tag" v-for="lise in liem.lable" :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
          {{liem.title}}
        </h3>
        <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="">
          <i class="contain_video">
            <video controlslist='nodownload' oncontextmenu="return false" ref="video" :src="liem.cover_video" preload controls :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"></video>
          </i>
        </div>
        <div class="list_right flex_center" v-else>
          <i class="contain_img" v-for="(liemT,indexT) in liem.cover" v-if="indexT<3">
            <img v-if="liemT" :src="liemT" alt="">
            <img v-else src="@/assets/img/app_logo.png" alt="">
          </i>
        </div>
        <div class="list_left flex_between">

          <div class="original clamp1 flex_center"><span>原创：{{liem.user}}</span> <span class="time clamp1">{{liem.create_time}}</span></div>
          <div class="list_describe clamp3" v-html="formatet(liem.content)">
          </div>
          <div class="list_time flex_between">

            <div class="flex_center operation">
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/liulanP.png" alt=""></i>
                {{liem.see}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                {{liem.goods}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                {{liem.comment}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 上边摘要 -->
      <div class="flex_between top_text left_text text_div" v-if="liem.summary_location == 1">

        <div class="list_left flex_between">
          <h3 class="list_title clamp1">
            <span class="list_tag" v-for="lise in liem.lable" :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
            {{liem.title}}
          </h3>
          <div class="original clamp1">原创：{{liem.user}}</div>
          <div class="list_describe clamp2" v-html="liem.content">
          </div>
          <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="">
            <i class="contain_video">
              <video controlslist='nodownload' oncontextmenu="return false" ref="video" :src="liem.cover_video" @click.stop="Videostate" preload controls :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"></video>
            </i>
          </div>
          <div class="list_right flex_start" v-else>
            <i class="contain_img" v-for="(liemT,indexT) in liem.cover" :class="{'max' : liem.cover.length == 1}" v-if="indexT<4">
              <img v-if="liemT" :src="liemT" alt="">
              <img v-else src="@/assets/img/app_logo.png" alt="">
            </i>
          </div>
          <div class="list_time flex_between">

            <span class="time clamp1">{{liem.create_time}}</span>
            <div class="flex_center operation">
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/liulanP.png" alt=""></i>
                {{liem.see}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                {{liem.goods}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                {{liem.comment}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 下边摘要 -->
      <div class="flex_between top_text bottom_text left_text text_div" v-if="liem.summary_location == 2">

        <div class="list_left flex_between">
          <h3 class="list_title clamp1">
            <span class="list_tag" v-for="lise in liem.lable" :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
            {{liem.title}}
          </h3>
          <div class="original clamp1">原创：{{liem.user}}</div>
          <div class="list_right flex_center" v-if="liem.cover_video" @click.stop="">
            <i class="contain_video">
              <video controlslist='nodownload' oncontextmenu="return false" ref="video" :src="liem.cover_video" preload controls :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"></video>
            </i>
          </div>
          <div class="list_right flex_start" v-else>
            <i class="contain_img" v-for="(liemT,indexT) in liem.cover" :class="{'max' : liem.cover.length == 1}" v-if="indexT<4">
              <img v-if="liemT" :src="liemT" alt="">
              <img v-else src="@/assets/img/app_logo.png" alt="">
            </i>
          </div>
          <div class="list_describe clamp2" v-html="liem.content">
          </div>

          <div class="list_time flex_between">

            <span class="time clamp1">{{liem.create_time}}</span>
            <div class="flex_center operation">
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/liulanP.png" alt=""></i>
                {{liem.see}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                {{liem.goods}}
              </div>
              <div class="flex_center operation_li">
                <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                {{liem.comment}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="complete" v-else>
    <div v-if="!is_loading" class="claloadding">
      <div>
        <img src="@/assets/img/loadding_pc.gif" alt="">
      </div>
      <div>努力加载中...</div>
    </div>
    <div v-else class="claloadding">
      <div>
        <img src="@/assets/img/kkry_pc.gif" alt="">
      </div>
      <div>{{noDataText?noDataText:'空空如也...'}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data() {
    return {

    }
  },
  props: {
    list_arr: {
      type: Array,
    },
    is_loading: {
      type: Boolean
    },
    noDataText: {
      type: String
    }
  },
  watch: {
    list_arr: function (eve) {
      // this.$refs.video["disablePictureInPicture"] = true;
    }
  },
  filters: {
    formatet(msg) {
      let sou = sessionStorage.getItem('search')
      return msg.replace("/" + sou + "/ig", '<span style="color:red">' + sou + '</span>')
    }
  },
  methods: {
    formatet(msg) {
      let sou = sessionStorage.getItem('search')
      let str = msg.replace(new RegExp(sou, 'g'), '<span style="color:red">' + sou + '</span>')

      return str
    },
    videoFun() {

      var au = document.getElementsByTagName("video");
      for (var i = 0; i < au.length; i++) {
        au[i].addEventListener("playing", function () {
          var this1 = this;
          this.play();
          for (var b = 0; b < au.length; b++) {
            var this2 = au[b];
            if (this1 !== this2) {
              this2.pause();
            }
          }
        });
      }
    },
    details(item) {//详情
      // if(item.cover_video){
      //   return false;
      // }
      this.$emit('detailsFun', item.news_id);
    },

  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.recommended_list {
  padding: 0 25px;
}

.recommended_list .recommended_li {
  padding: 30px 10px 30px 25px;
  border-radius: 4px;
  border-bottom: 1px solid #dfdfdf;

  cursor: pointer;
  transition: all 0.5s ease;
}

.recommended_list .recommended_li .text_div {
  width: 100%;
  height: 100%;
}

.recommended_li .list_left {
  flex: 1;
  margin-right: 15px;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
}

.text_div .list_title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  align-items: flex-start;
  width: 100%;
}

.text_div .list_title > .list_tag {
  border-radius: 4px;
  border: 2px solid #9749bb;
  color: #9749bb;
  font-size: 14px;
  margin-right: 10px;
  position: relative;
  top: -1px;
  padding: 0 10px;
  line-height: 24px;
  height: 24px;
  white-space: nowrap;
}

.recommended_li .list_describe {
  font-size: 14px;
  color: #666;
}

.recommended_li .list_time {
  width: 100%;
  margin-top: 10px;
}

.recommended_li .original {
  font-size: 15px;
  color: #333;
  margin: 10px 0;
}

.recommended_li .list_time .time {
  font-size: 14px;
  color: #999;
}

.recommended_li .list_time .operation .operation_li {
  font-size: 14px;
  color: #999;
  margin-right: 24px;
}

.recommended_li .list_time .operation .operation_li > i {
  width: 15px;
  margin-right: 4px;
}

.recommended_li .list_right {
  height: 100%;
  overflow: hidden;
}

.recommended_li .list_right .contain_img {
  margin-left: 10px;
  width: 160px;
  border-radius: 4px;
  overflow: hidden;
  height: 130px;
  background: transparent;
}

.recommended_li .list_right .contain_img > img {
  transition: all 0.5s ease;
  object-fit: cover;
}

.recommended_list .recommended_li:hover {
  background: #f4f4f4;
}

.recommended_list .recommended_li:hover .list_right > .contain_img img {
  transform: scale(1.2);
}

.recommended_list .recommended_li .list_right .contain_video {
  width: 100%;
}

.recommended_list .recommended_li .list_right .contain_video > video {
  width: 100%;
}

/* 载要左边 */
.recommended_list .recommended_li .left_text {
  min-height: 160px;
  flex-wrap: wrap;
}

.recommended_list .recommended_li .left_text .list_describe {
  height: 60px;
}

.recommended_list .recommended_li .left_text .original .time {
  font-size: 14px;
  color: #999;
  margin-left: 10px;
}

.recommended_list .recommended_li .left_text.div_zuoyou .list_title {
  margin-bottom: 20px;
}

.recommended_list .recommended_li .left_text.div_zuoyou .list_right {
  height: 140px;
}

.recommended_list .recommended_li .left_text.div_zuoyou .list_left {
  height: 140px;
}

.recommended_list
  .recommended_li
  .left_text.div_zuoyou
  .list_right
  .contain_video {
  width: 250px;
  margin-right: 10px;
}

/* 右边摘要  */
.recommended_list .recommended_li .left_text.rigth_text .contain_img {
  margin: 0 10px 0 0;
}

/* 上边摘要 */

.recommended_list .recommended_li .left_text.top_text {
  flex-direction: column;
  width: 100%;
  height: auto;
}

.recommended_list .recommended_li .left_text.top_text .list_describe {
  height: auto;
  margin-top: 10px;
}

.recommended_list .recommended_li .left_text.top_text .list_left {
  width: 100%;
}

.recommended_list .recommended_li .left_text.top_text .list_right {
  white-space: wrap;
  flex-wrap: wrap;
  width: 100%;
}

.recommended_list .recommended_li .left_text.top_text .list_right .contain_img {
  margin: 10px 10px 10px 0;
}

.recommended_list .recommended_li .left_text.top_text .list_right .contain_img {
  margin: 10px 10px 10px 0;
}

.recommended_list .recommended_li .left_text.top_text .contain_img.max {
  width: 100%;
  height: auto;
}
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/listLi.vue